/**
 * Make payload API friendly
 * @param {*} data
 * @returns denormalised api friendly payload
 */
export function denormaliseOrderSummary(formPayload) {
  const payload = {
    first_name: formPayload.name.value,
    post_code: formPayload.postal.value,
    stateId: formPayload.stateId.value,
    countryId: formPayload.countryId.value,
    addressee: formPayload.name.value,
    // If apartment is provided, add it to the address_1 field to be consistent with the shipbob address format
    address_1: formPayload.apartment.value
      ? `${formPayload.apartment.value} - ${formPayload.address.value}`
      : formPayload.address.value,
    city: formPayload.locality.value,
    delivery_method_id: formPayload.deliveryMethod.value,
    voucher_code: formPayload.voucher.value,
    no_headset_required: formPayload.headsetType.value,
    plan_id: formPayload?.plan_id?.value,
  };

  return payload;
}

export function denormaliseNoHeadsetOrderSummary(formPayload) {
  const payload = {
    first_name: formPayload.name.value,
    voucher_code: formPayload.voucher.value,
    no_headset_required: formPayload.headsetType.value,
    plan_id: formPayload?.plan_id?.value,
    item_type: "Plan",
    item_id: formPayload?.plan_id?.value,
  };

  return payload;
}
